// extracted by mini-css-extract-plugin
export default {"wrapper":"PillarsBlendTile_wrapper__I-FwS","label":"PillarsBlendTile_label__J6ka1"};